var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon",class:`${_vm.iconId}`,attrs:{"aria-label":_vm.ariaLabel,"title":_vm.title}},[_c('svg',{staticClass:"icon__svg"},[_c('use',{staticClass:"icon__use",attrs:{"xlink:href":`#${_vm.iconId}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }